import { createContext, useContext, useEffect, useMemo, useState } from "react"
import { doc, onSnapshot } from "firebase/firestore"
import { db } from "../../configs/firebase"

const DocumentContext = createContext()

export const DocumentProvider = ({ children }) => {
  const [document, setDocument] = useState(null)
  const [documentId, setDocumentId] = useState(null)

  useEffect(() => {
    if (!documentId) return
    const ref = doc(db, 'documents', documentId)
    const unsubscribe = onSnapshot(
      ref,
      (snap) => setDocument(snap.exists() ? snap.data() : null),
      (err) => {
        console.error("Document snapshot error:", err)
        setDocument(null)
      }
    )
    return () => unsubscribe()
  }, [documentId])

  const reset = () => {
    setDocumentId(null)
    setDocument(null)
  }

  const value = useMemo(
    () => ({
      _isDocumentExists: !!document,
      document,
      documentId,
      setDocumentId,
      reset,
    }),
    [document, documentId]
  )

  return (
    <DocumentContext.Provider value={value}>
      {children}
    </DocumentContext.Provider>
  )
}

export const useDocumentContext = () => {
  const ctx = useContext(DocumentContext)
  if (!ctx)
    throw new Error("useDocumentContext must be used within DocumentProvider")
  return ctx
}
